<app-loader *ngIf="showLoader"></app-loader>
@if (gridConfig) {
<div [style.height.px]="gridHeight">
    <!-- A negative total in red, as the old footer templates. -->
    <inavista-grid #cycleCountCostAnalysisGrid class="so-popup-grid" style="--inavista-grid-total-negative-color: red"
        [config]="gridConfig"
        [actionIcons]="actionIcons"
        (hyperlinkClick)="showMasterItemCodePopup(itemFor($event.row))"
        (rowCommit)="onRowCommit($event)"
        (actionIconClick)="onActionIconClick($event)"
        (toolbarActionClick)="onToolbarActionClick($event)"
        (exportRequested)="onExportRequested()" />
</div>
}

<app-cycle-counts-upload-detail *ngIf="showUploadDetailPopup"
    [uploadDetailData]="uploadDetailData"
    (browseFile)="onBrowseFile()"
    (reloadPopupData)="reloadPopupData.emit(); this.isFileUploaded.emit(true); updateList()"
    [showLoader]="showLoader"
    [fileInvalid]="fileInvalid"
    [cycleCountId]="cycleCountId"
    (onClose)="showUploadDetailPopup = false"
    >
</app-cycle-counts-upload-detail>

<!-- <app-cycle-count-inventory-quantity
    [itemDate]="inventoryQuantityData"
    [warehouseId]="warehouseId"
    *ngIf="showItemLinkPopup"
    (onClose)="showItemLinkPopup = false"
    >
</app-cycle-count-inventory-quantity> -->

<app-inventory-popup
    *ngIf="showItemLinkPopup"
    [itemCode]="itemCode"
    [warehouse]="warehouse"
    [popupTitle]="popupTitle"
    [secondDescrption]="openLinkSecondDescrption"
    (onClose)="showItemLinkPopup = false"
    (onSave)="showItemLinkPopup = false"
></app-inventory-popup>

<input #fileInputRef type="file" style="display: none" (change)="onFileSelected($event)" accept=".xlsx">
